import request from "./request";
import {
  baseUrl
} from "@/utils/auth";
/**
 * 用户相关接口
 * @author 小圣贤君
 * @time 2020/03/12
 */
export default {
  /**
   * 获取uuid
   */
  getUuid() {
    return request.get("/sys/uuid");
  },
  /**
   * 获取图形验证码
   * @param uuid 
   */
  getImgCode(uuid) {
    return baseUrl() + "/captcha.jpg?uuid=" + uuid;
  },
  /**
   * 获取短信验证码
   * @param mobile 手机号
   * @param captcha 图片验证码
   * @param uuid
   */
  getMsgCode(mobile, captcha, uuid) {
    return request.post("/msg/sms/sendcode?mobile=" + mobile + "&captcha=" + captcha + "&uuid=" + uuid);
  },
  /**
   * 绑定手机号
   * @param mobile 手机号
   * @param wechatCode 微信code
   * @param code 短息验证码
   */
  bindMobile(mobile, code, wechatCode) {
    return request.post("/user/bingPhone?mobile=" + mobile + "&code=" + code + "&wechatCode=" + wechatCode);
  },
  /**
   * 微信登录
   * @param code 微信授权code
   */
  wxLogin(code) {
    return request.get("/user/wechat/weChatLogin?code=" + code);
  },
  /**
   * 查询库存
   */
  queryStock(productId) {
    return request.post("/shop/shopstock/rush/stock?productId=" + productId);
  },
  /**
   * 获取用户信息
   */
  getUserInfo() {
    return request.get("/user/myInfo");
  },
  /**
   * 退出
   */
  logout() {
    return request.post("/user/sys/logout");
  },
  /**
   * 获取考核信息
   */
  agentExamineCycle() {
    return request.get('/user/agentExamineCycle');
  }
}



// WEBPACK FOOTER //
// ./src/api/userService.js